// Client for the `assistant` Edge Function. The model key lives only there;
// the browser sends the conversation and receives text + safe UI actions.
import { env } from './env';
import { supabaseFor } from './supabase';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface AssistantAction {
  type: 'open_booking';
  service_id?: string;
  label: string;
}

export interface AssistantReply {
  reply: string;
  actions: AssistantAction[];
  suggestions: string[];
}

export async function askAssistant(
  slug: string,
  scope: 'client' | 'owner',
  messages: ChatMessage[],
  tenantId?: string,
): Promise<AssistantReply> {
  const client = supabaseFor(slug);
  const { data: session } = await client.auth.getSession();
  const res = await fetch(`${env.supabaseUrl}/functions/v1/assistant`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      apikey: env.supabaseAnonKey,
      authorization: `Bearer ${scope === 'owner' && session.session ? session.session.access_token : env.supabaseAnonKey}`,
    },
    body: JSON.stringify({ slug, scope, tenant_id: tenantId, messages: messages.slice(-12) }),
  }).catch(() => null);
  if (!res) throw new Error('Нет связи с сервером');
  const body = (await res.json().catch(() => null)) as (AssistantReply & { error?: { message: string } }) | null;
  if (!res.ok || !body || body.error) {
    throw new Error(body?.error?.message ?? (res.status === 429 ? 'Помощник занят, попробуйте через минуту' : 'Помощник сейчас недоступен'));
  }
  return { reply: body.reply, actions: body.actions ?? [], suggestions: body.suggestions ?? [] };
}
